import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../axios/axios";

export const fetchGoogleCalendarUser = async (username) => {
  try {
    if (!username) {
      throw new Error("Username is required");
    }

    const { data } = await getRequest(
      `/api/v1/meetings/google-calendar?username=${username}`,
    );

    if (data.status === "success") {
      return data.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getMeetLink = async () => {
  try {
    const { data } = await getRequest(
      "/api/v1/meetings/google-meet/instant",
      localStorage.getItem("token"),
    );

    if (data.status === "success") {
      return data.data.meetLink;
    }
  } catch (err) {
    throw err;
  }
};

export const scheduleMeeting = async ({ meetingEventId, ...payload }) => {
  try {
    const { data } = await postRequest(
      `/api/v1/meetings/google-meet/${meetingEventId}`,
      undefined,
      payload,
    );

    if (data.status === "success") {
      return data.data.meeting;
    }
  } catch (err) {
    throw err;
  }
};

export const rescheduledMeeting = async ({ calendarEventId, ...payload }) => {
  try {
    const { data } = await patchRequest(
      `/api/v1/meetings/google-meet/${calendarEventId}`,
      payload,
    );

    if (data.status === "success") {
      return data.data.meeting;
    }
  } catch (err) {
    throw err;
  }
};

export const fetchMeeting = async (calendarEventid) => {
  try {
    const { data } = await getRequest(
      `/api/v1/meetings/google-meet/${calendarEventid}`,
    );

    if (data.status === "success") {
      return data.data.meeting;
    }
  } catch (err) {
    throw err;
  }
};

export const cancelMeeting = async ({ calendarEventId, ...payload }) => {
  try {
    const { data } = await deleteRequest(
      `/api/v1/meetings/google-meet/${calendarEventId}`,
      undefined,
      undefined,
      payload,
    );

    if (data.status === "success") {
      return data.data.meeting;
    }
  } catch (err) {
    throw err;
  }
};
